/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

import { CardColorProps } from '../BaseIcon'

export const Applepay: FunctionComponent<CardColorProps> = ({ blackAndWhite = false }) => (
  <React.Fragment>
    {!blackAndWhite && (
      <React.Fragment>
        <rect width='40' height='24' rx='2' fill='white' />
        <g clipPath='url(#clip0_20400_16)'>
          <path
            d='M10.9195 8.0725C11.262 7.67101 11.4944 7.13193 11.4332 6.58105C10.9318 6.60442 10.32 6.89105 9.96577 7.29286C9.64773 7.63694 9.36623 8.19859 9.43962 8.72638C10.0024 8.77213 10.5647 8.46273 10.9195 8.0725Z'
            fill='black'
          />
          <path
            d='M11.4269 8.82923C10.6096 8.7836 9.9147 9.26398 9.52438 9.26398C9.13385 9.26398 8.53615 8.85222 7.88969 8.86332C7.04828 8.8749 6.26755 9.32077 5.84058 10.0299C4.96235 11.4486 5.60881 13.5529 6.46284 14.7083C6.87757 15.2799 7.3774 15.9093 8.03599 15.8867C8.65826 15.8638 8.90216 15.5091 9.65855 15.5091C10.4144 15.5091 10.6341 15.8867 11.2928 15.8753C11.9759 15.8638 12.4029 15.3034 12.8177 14.7312C13.2934 14.0796 13.4882 13.4504 13.5005 13.4159C13.4882 13.4044 12.1833 12.9352 12.1712 11.5284C12.1588 10.3504 13.1957 9.7901 13.2445 9.75535C12.659 8.94374 11.7441 8.85222 11.4269 8.82923Z'
            fill='black'
          />
          <path
            d='M18.5435 7.23535C20.32 7.23535 21.557 8.383 21.557 10.0539C21.557 11.7307 20.2945 12.8843 18.499 12.8843H16.5321V15.8158H15.1111V7.23535H18.5435V7.23535ZM16.5321 11.7664H18.1627C19.4 11.7664 20.1041 11.1421 20.1041 10.0598C20.1041 8.97769 19.4 8.35925 18.1691 8.35925H16.5321V11.7664Z'
            fill='black'
          />
          <path
            d='M21.9282 14.0378C21.9282 12.9436 22.8228 12.2718 24.4091 12.1885L26.2362 12.0874V11.6058C26.2362 10.9101 25.7349 10.4939 24.8976 10.4939C24.1044 10.4939 23.6095 10.8506 23.489 11.4096H22.1948C22.2709 10.2797 23.2986 9.44727 24.9483 9.44727C26.5661 9.44727 27.6002 10.25 27.6002 11.5047V15.8157H26.2868V14.787H26.2553C25.8683 15.4828 25.0244 15.9227 24.1489 15.9227C22.8419 15.9227 21.9282 15.1616 21.9282 14.0378ZM26.2362 13.473V12.9794L24.5929 13.0745C23.7744 13.1281 23.3113 13.467 23.3113 14.0022C23.3113 14.5491 23.7935 14.906 24.5295 14.906C25.4875 14.906 26.2362 14.2875 26.2362 13.473Z'
            fill='black'
          />
          <path
            d='M28.8404 18.1173V17.0766C28.9417 17.1004 29.1701 17.1004 29.2844 17.1004C29.9188 17.1004 30.2615 16.8507 30.4707 16.2085C30.4707 16.1966 30.5914 15.828 30.5914 15.822L28.1805 9.56055H29.665L31.3528 14.6506H31.378L33.0659 9.56055H34.5124L32.0124 16.143C31.4417 17.6594 30.7818 18.147 29.3987 18.147C29.2844 18.147 28.9417 18.1351 28.8404 18.1173Z'
            fill='black'
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M38 1H2C1.44771 1 1 1.44772 1 2V22C1 22.5523 1.44772 23 2 23H38C38.5523 23 39 22.5523 39 22V2C39 1.44772 38.5523 1 38 1ZM2 0C0.895431 0 0 0.89543 0 2V22C0 23.1046 0.895431 24 2 24H38C39.1046 24 40 23.1046 40 22V2C40 0.895431 39.1046 0 38 0H2Z'
            fill='black'
          />
        </g>
        <defs>
          <clipPath id='clip0_20400_16'>
            <rect width='40' height='24' fill='white' />
          </clipPath>
        </defs>
      </React.Fragment>
    )}
    {blackAndWhite && (
      <React.Fragment>
        <g clipPath='url(#clip0_20400_17)'>
          <rect width='40' height='24' rx='2' fill='white' />
          <path
            d='M10.9197 8.0725C11.2622 7.67101 11.4946 7.13193 11.4333 6.58105C10.9319 6.60442 10.3201 6.89105 9.96589 7.29286C9.64785 7.63694 9.36635 8.19859 9.43974 8.72638C10.0025 8.77213 10.5648 8.46273 10.9197 8.0725Z'
            fill='black'
          />
          <path
            d='M11.4271 8.82923C10.6097 8.7836 9.91482 9.26398 9.5245 9.26398C9.13397 9.26398 8.53628 8.85222 7.88981 8.86332C7.04841 8.8749 6.26768 9.32077 5.8407 10.0299C4.96247 11.4486 5.60894 13.5529 6.46296 14.7083C6.87769 15.2799 7.37752 15.9093 8.03612 15.8867C8.65838 15.8638 8.90228 15.5091 9.65867 15.5091C10.4145 15.5091 10.6342 15.8867 11.2929 15.8753C11.976 15.8638 12.4031 15.3034 12.8178 14.7312C13.2936 14.0796 13.4883 13.4504 13.5006 13.4159C13.4883 13.4044 12.1834 12.9352 12.1713 11.5284C12.159 10.3504 13.1958 9.7901 13.2446 9.75535C12.6591 8.94374 11.7442 8.85222 11.4271 8.82923Z'
            fill='black'
          />
          <path
            d='M18.5437 7.23535C20.3201 7.23535 21.5571 8.383 21.5571 10.0539C21.5571 11.7307 20.2947 12.8843 18.4991 12.8843H16.5323V15.8158H15.1112V7.23535H18.5437V7.23535ZM16.5323 11.7664H18.1628C19.4001 11.7664 20.1042 11.1421 20.1042 10.0598C20.1042 8.97769 19.4001 8.35925 18.1692 8.35925H16.5323V11.7664Z'
            fill='black'
          />
          <path
            d='M21.9283 14.0378C21.9283 12.9436 22.8229 12.2718 24.4092 12.1885L26.2363 12.0874V11.6058C26.2363 10.9101 25.735 10.4939 24.8977 10.4939C24.1045 10.4939 23.6096 10.8506 23.4892 11.4096H22.1949C22.271 10.2797 23.2987 9.44727 24.9484 9.44727C26.5662 9.44727 27.6003 10.25 27.6003 11.5047V15.8157H26.287V14.787H26.2554C25.8684 15.4828 25.0245 15.9227 24.149 15.9227C22.842 15.9227 21.9283 15.1616 21.9283 14.0378ZM26.2363 13.473V12.9794L24.593 13.0745C23.7745 13.1281 23.3115 13.467 23.3115 14.0022C23.3115 14.5491 23.7936 14.906 24.5296 14.906C25.4876 14.906 26.2363 14.2875 26.2363 13.473Z'
            fill='black'
          />
          <path
            d='M28.8405 18.1173V17.0766C28.9419 17.1004 29.1702 17.1004 29.2845 17.1004C29.9189 17.1004 30.2616 16.8507 30.4709 16.2085C30.4709 16.1966 30.5915 15.828 30.5915 15.822L28.1807 9.56055H29.6651L31.353 14.6506H31.3782L33.066 9.56055H34.5125L32.0126 16.143C31.4418 17.6594 30.7819 18.147 29.3988 18.147C29.2845 18.147 28.9419 18.1351 28.8405 18.1173Z'
            fill='black'
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M38 1H2C1.44771 1 1 1.44772 1 2V22C1 22.5523 1.44772 23 2 23H38C38.5523 23 39 22.5523 39 22V2C39 1.44772 38.5523 1 38 1ZM2 0C0.895431 0 0 0.89543 0 2V22C0 23.1046 0.895431 24 2 24H38C39.1046 24 40 23.1046 40 22V2C40 0.895431 39.1046 0 38 0H2Z'
            fill='black'
          />
        </g>
        <defs>
          <clipPath id='clip0_20400_17'>
            <rect width='40' height='24' rx='2' fill='white' />
          </clipPath>
        </defs>
      </React.Fragment>
    )}
  </React.Fragment>
)
